// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"42ac8d52","681":"a0b3bd00"}[chunkId] + ".chunk.css";
};